angular.module('pitch.app')

.factory('Track', function(config, $resource) {
    return $resource(config.apiUri + '/tracks/:id', {
        id: '@id'
    });
})

.factory('Tags', function(config, $resource) {
    return $resource(config.apiUri + '/tracks/:trackId/tags', {
        trackId: '@trackId'
    });
})

.factory('Chart', function(config, $resource) {
    return $resource(config.apiUri + '/tracks/:trackId/charts', {
        trackId: '@trackId'
    });
})

.factory('Lyrics', function(config, $resource) {
    return $resource(config.apiUri + '/tracks/:trackId/lyrics', {
        trackId: '@trackId'
    });
})

;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/Track.js